import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Content from "../components/content"

export const query = graphql`
  query($slug: String!) {
    competenciesJson(slug: { eq: $slug }) {
      id
      title
      description
      tag
      photo
      theme
      image {
        childImageSharp {
          fluid(maxWidth: 2014, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`

const CompetenciesTemplate = ({ data }) => {
  const content = data.competenciesJson

  return (
    <Layout pageTitle={content.title}>
      <Content
        slide={content.id}
        title={content.title}
        imageData={content.image.childImageSharp.fluid}
        description={content.description}
        photo={content.photo}
        tag={content.tag}
        theme={content.theme}
      />
    </Layout>
  )
}

export default CompetenciesTemplate
